/**
 * Map an OrgMember row to its effective access state — extracted from
 * Organizations.tsx so the Vitest spec can import it without pulling
 * in the full component tree (auth-fetch + window globals).
 *
 * Three cases, in priority order:
 *   1. backend already computed effective_admin_approved → trust it
 *   2. only raw fields present → AND them (matches server's
 *      checkOrgAccess invariant)
 *   3. legacy: no fields → 'unknown', counted as active so the UI
 *      doesn't regress to "0 active + N deactivated" on clusters
 *      that haven't deployed PR #2311's backend yet
 */

export type EffectiveState = 'active' | 'inactive' | 'unknown';

export interface EffectiveInput {
  admin_approved?: boolean;
  user_admin_approved?: boolean;
  effective_admin_approved?: boolean;
}

export function deriveMemberEffective(m: EffectiveInput): EffectiveState {
  if (typeof m.effective_admin_approved === 'boolean') {
    return m.effective_admin_approved ? 'active' : 'inactive';
  }
  if (typeof m.admin_approved === 'boolean'
      && typeof m.user_admin_approved === 'boolean') {
    return (m.admin_approved && m.user_admin_approved) ? 'active' : 'inactive';
  }
  return 'unknown';
}
